export default "../../../static/plugins/visualizations/nora/static/assets/fontawesome-webfont.a3de2170e4e9df77161ea5d3f31b2668.ttf";